import { useEffect, useState } from "react";
import { DEFAULT_TIMELINE_STATE, TRADITION_LAYERS } from "./config";

const BOOLEAN_PARAMS = Object.freeze([
  ["events", "events"],
  ["periods", "periods"],
  ...TRADITION_LAYERS.map(({ slug }) => [slug, slug])
]);

export function readTimelineState(initial = DEFAULT_TIMELINE_STATE) {
  if (typeof window === "undefined") return initial;

  const query = new URLSearchParams(window.location.search);
  const state = {
    ...DEFAULT_TIMELINE_STATE,
    ...initial,
    mainstreamFigures: query.has("mainstream")
      ? query.get("mainstream") !== "0"
      : initial.mainstreamFigures,
    allFigures: query.has("figures")
      ? query.get("figures") === "all"
      : initial.allFigures
  };

  BOOLEAN_PARAMS.forEach(([stateKey, parameter]) => {
    if (query.has(parameter)) state[stateKey] = query.get(parameter) === "1";
  });

  return state;
}
export function writeTimelineState(state) {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);
  if (state.mainstreamFigures) url.searchParams.delete("mainstream");
  else url.searchParams.set("mainstream", "0");

  if (state.allFigures) url.searchParams.set("figures", "all");
  else url.searchParams.delete("figures");

  BOOLEAN_PARAMS.forEach(([stateKey, parameter]) => {
    if (state[stateKey]) url.searchParams.set(parameter, "1");
    else url.searchParams.delete(parameter);
  });

  window.history.replaceState(window.history.state, "", url);
}

export function useTimelineState(initial) {
  const [state, setState] = useState(() => readTimelineState(initial));

  useEffect(() => writeTimelineState(state), [state]);
  useEffect(() => {
    const restore = () => setState(readTimelineState(DEFAULT_TIMELINE_STATE));
    window.addEventListener("popstate", restore);
    return () => window.removeEventListener("popstate", restore);
  }, []);

  const setLayer = (key, checked) => {
    setState((current) => ({ ...current, [key]: checked }));
  };

  return { state, setLayer };
}
